<template>
  <div>
    <el-button style="display: block" type="primary" @click="openPop">
      <i class="el-icon-plus"></i>
      添加供应商
    </el-button>
    <el-tag
      v-for="(tag, index) in selectionRow"
      :key="tag.id"
      class="l-margin"
      closable
      @close="closeTag(index)"
    >
      {{ tag.name }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: 'PopController',

  props: {
    selectedList: {
      type: Array,
      default: () => []
    },

    normalizeMap: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      visible: false,
      selectionRow: []
    }
  },

  methods: {
    openPop() {
      this.$emit('open')
    },

    closeTag(index) {
      this.selectionRow.splice(index, 1)
    }
  }
}
</script>

<style scoped></style>
